import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateIncidentsGrid = document.createElement('template');

templateIncidentsGrid.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

    <gz-push-body-layout resizable="right">
      <div slot="push-body-sidenav">
           <gz-generic-grid-smart-views class="hidden" id="smart-views" hasSearchInput="true">

           </gz-generic-grid-smart-views>
           <div class="loader">
              <gz-loader rows="4" class="smartview-loader"></gz-loader>
              <gz-loader rows="4" class="smartview-loader"></gz-loader>
          </div>
      </div>
      <div slot="push-body-sidenav-title">
          <gz-title id="smartViewsTitle" fontweight="600" fontsize="11"></gz-title>
      </div>

      <div class="alerts push-body"  slot="push-body-content">
        <div class="push-body--menu"></div>

        <div class="push-body--content">
          <div class="wrapper">
            <div class="page__header">
              <gz-title class="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
            </div>
            <div class="alerts-content">
                <div class="alerts-grid">
                    <gz-grid-view enableCSVExport noEscapeSpaceInTitle showGlobalActions>
                      <div class="header-buttons hidden" slot="grid-header-actions-slot">
                        <gz-select id="change-status-bulk-button" overlayPositionX="left" class="inline-block">
                          <gz-button class="action-split-button">
                            <span id='change-status-bulk-button-text'></span>
                            <span class="icon action-icon ds-icon-dropdown_arrow"></span>
                          </gz-button>
                        </gz-select>
                        <gz-select id="prioritize-bulk-button" overlayPositionX="left" class="inline-block">
                          <gz-button class="action-split-button" type="quiet" color="secondary">
                            <span id='prioritize-bulk-button-text'></span>
                            <span class="icon action-icon ds-icon-dropdown_arrow"></span>
                          </gz-button>
                        </gz-select>
                        <gz-select-menu-with-button id="assign-bulk-button" buttonType="quiet" buttonColor="secondary" overlayPositionX="left" class="inline-block">
                        </gz-select-menu-with-button>
                      </div>
                      <div class="demo-mode-container hidden" slot="grid-header-actions-toolbar-slot">
                          <gz-icon-button icon="ds-icon-demo-mode" id="demo-mode-button" size="24" fontsize="20" buttontype="square" buttonfill="quiet" buttoncolor="secondary"></gz-icon-button>
                        </div>
                    </gz-grid-view>
                </div>
              </div>

            <gz-image-repo state="error" class="loading-error">
                <gz-text fontSize="14" fontWeight="400" class="loading-error--message" />
            </gz-image-repo>
          </div>
          <gz-side-menu id="sideMenu" menuwidth="400" closeOnClickOutside resizable="left" class="push-body-sidenav resize-content">
          </gz-side-menu>
        </div>
      </div>

    </gz-push-body-layout>

`;
